import React from "react";

import { useSelector } from "react-redux";

import HomePage from "./Home";
import Login from "../../components/Login";
function Home() {
  const { isLoggedIn } = useSelector((state) => state.authentication);
  return <>{!isLoggedIn ? <Login /> : <HomePage />}</>;
}

export default Home;
